<template>
  <v-app>
    <v-content>
      <navigation v-if="['Dashboard', 'Report', 'Clients', 'Content', 'AccountView', 'AdminUsers', 'ActivityHistory'].indexOf($route.name) > -1" class="no-print"></navigation>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import router from './router'
import Navigation from './components/Navigation'
export default {
  name: 'App',
  components: {
    Navigation
  },
  data () {
    return {
    }
  }
}
</script>
<style> 
.button-style{
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0;
}
</style>
